import cn from "clsx";
import { LegacyRef, forwardRef } from "react";

interface InputElementProps {
    name: string;
    value?: string;
    type: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
    inputRef?: LegacyRef<HTMLInputElement> | undefined;
    className?: string;
    disabled?: boolean;
    pattern?: string;
    required?: boolean;
}
export const InputElement = ({ name, value, inputRef, type = "text", placeholder, className, onChange, disabled = false, pattern, required }: InputElementProps) => (
    <div className={cn("flex items-center rounded-xl flex-start border", disabled ? "border-gray-100" : "")}>
        <input
            className={cn(className, disabled ? "bg-gray-100" : "bg-white", "w-full p-2.5 text-gray-700 placeholder-gray-400  border-none rounded-xl focus:bg-gray-100 focus:outline-none focus:ring-0")}
            name={name}
            defaultValue={value}
            onChange={onChange}
            placeholder={placeholder}
            ref={inputRef}
            type={type}
            disabled={disabled}
            pattern={pattern}
            required={required}
            autoFocus={false}
            tabIndex={-1}
        />
    </div>
)